import { useState } from 'react';
import api from './api';

export default function Login({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const res = await api.post('/login', { username, password });
      localStorage.setItem('token', res.data.token);
      localStorage.setItem('user', JSON.stringify(res.data.user));
      onLogin(res.data.user);
    } catch (err) {
      setError(err.response?.data?.error || '登录失败');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={s.root}>
      <div style={s.card}>
        <div style={s.logo}>⬡</div>
        <div style={s.title}>预混料管理系统</div>
        <div style={s.subtitle}>牛场供应链追踪平台</div>
        <form onSubmit={handleSubmit}>
          <div style={s.fieldWrap}>
            <span style={s.fieldIcon}>👤</span>
            <input style={s.input} placeholder="用户名" value={username}
              onChange={e => setUsername(e.target.value)} required autoComplete="username" />
          </div>
          <div style={s.fieldWrap}>
            <span style={s.fieldIcon}>🔒</span>
            <input style={s.input} type="password" placeholder="密码" value={password}
              onChange={e => setPassword(e.target.value)} required autoComplete="current-password" />
          </div>
          {error && <div style={s.error}>{error}</div>}
          <button style={{ ...s.btn, opacity: loading ? 0.7 : 1 }} type="submit" disabled={loading}>
            {loading ? '登录中...' : '登录'}
          </button>
        </form>
        <div style={s.roles}>
          <div style={s.rolesTitle}>系统角色</div>
          <div style={s.roleList}>
            {['预混料销售部', '牛场采购', '牛场库管', '代工厂', '管理员'].map(r => (
              <span key={r} style={s.roleTag}>{r}</span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

const s = {
  root: {
    minHeight: '100vh', background: '#070d1a',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    backgroundImage: 'radial-gradient(ellipse at 20% 50%, #0d2040 0%, transparent 60%), radial-gradient(ellipse at 80% 20%, #0a1a35 0%, transparent 50%)',
  },
  card: {
    background: '#0d1529', border: '1px solid #1e2d4a', borderRadius: 20,
    padding: '44px 40px', width: 'min(400px,92vw)', boxShadow: '0 24px 80px rgba(0,0,0,0.5)',
  },
  logo: { fontSize: 40, color: '#38bdf8', textAlign: 'center', marginBottom: 10 },
  title: { color: '#f1f5f9', fontSize: 20, fontWeight: 800, textAlign: 'center', letterSpacing: '0.05em', fontFamily: "'DM Mono', monospace" },
  subtitle: { color: '#475569', fontSize: 12, textAlign: 'center', marginBottom: 32, marginTop: 4, letterSpacing: '0.08em' },
  fieldWrap: { position: 'relative', marginBottom: 14 },
  fieldIcon: { position: 'absolute', left: 12, top: '50%', transform: 'translateY(-50%)', fontSize: 14 },
  input: {
    display: 'block', width: '100%', background: '#0a1628', border: '1px solid #2d3f5f',
    color: '#e2e8f0', padding: '11px 14px 11px 36px', borderRadius: 9, fontSize: 14,
    boxSizing: 'border-box', fontFamily: 'inherit', outline: 'none',
  },
  error: { color: '#f87171', fontSize: 13, marginBottom: 12, textAlign: 'center', background: '#2d0f0f', borderRadius: 7, padding: '8px 12px' },
  btn: {
    width: '100%', background: 'linear-gradient(135deg, #1d4ed8, #2563eb)', color: '#fff',
    border: 'none', padding: '12px', borderRadius: 9, fontSize: 15, fontWeight: 700,
    cursor: 'pointer', fontFamily: 'inherit', marginTop: 4, letterSpacing: '0.03em',
  },
  roles: { marginTop: 28, borderTop: '1px solid #1e2d4a', paddingTop: 20 },
  rolesTitle: { color: '#334155', fontSize: 11, letterSpacing: '0.1em', marginBottom: 10, textAlign: 'center' },
  roleList: { display: 'flex', flexWrap: 'wrap', gap: 6, justifyContent: 'center' },
  roleTag: { background: '#0f2040', color: '#38bdf8', border: '1px solid #1e3a5f', borderRadius: 20, padding: '3px 10px', fontSize: 11 },
};
